












import Vue from 'vue'
import { columnConstants, Column, columns } from '@/helpers/columnConstants'
import { TableSetting } from '@/models/dataTable'
import kanbanColumn from '@/components/DataTable/Kanban/KanbanColumn.vue'
import { KANBAN_RENAMED_COLUMNS } from '@/constants/dataTable'

interface Props {
  showFilters: boolean
  tableSetting: TableSetting
}

interface Data {
  columns: string[]
  allColumns: Column[]
}

interface Methods {
  getColumns: (newColumn: string) => void
  title: (columnName: string) => string
}
interface Computed {
  keyName: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    kanbanColumn,
  },
  props: {
    showFilters: {
      required: true,
    },
    tableSetting: {
      required: true,
    },
  },
  data() {
    return {
      columns: [],
      allColumns: [],
    }
  },
  methods: {
    getColumns(newColumn) {
      this.columns =
        columns?.find(elem => {
          return elem.key === newColumn
        })?.values || []
    },
    title(columnName) {
      const col = columns.find(elem =>
        elem.key.includes(this.$route.query.kanbanColumn as string),
      ) as Column
      return col.titles[col.values.indexOf(columnName)]
    },
  },
  computed: {
    keyName() {
      const column: string = this.$route.query.kanbanColumn as string
      if (Object.keys(KANBAN_RENAMED_COLUMNS).includes(column)) {
        return (KANBAN_RENAMED_COLUMNS as { [key: string]: string })[column]
      }
      return column
    },
  },
  watch: {
    '$route.query.kanbanColumn'(newColumn) {
      this.getColumns(newColumn)
    },
  },
  async mounted() {
    columnConstants().then(() => {
      if (this.$route.query.kanbanColumn) {
        return this.getColumns(this.$route.query.kanbanColumn as string)
      }
      const query = Object.assign({}, this.$route.query)
      const kanbanColumn = { kanbanColumn: columns[0].key }
      this.$router.replace({ query: { ...query, ...kanbanColumn } })
      this.getColumns(`${columns[0].key}`)
    })
  },
})
